// ADR-199: Reports → Integrity Checks — radar-api's read-only integrity routes
// (ADR-153 step B). Each call runs the checks live.
import { authenticatedApi, ApiError, API_BASE_URL } from './apiUtils';

const PATHS = {
  employment: '/employment/integrity',
  'org-edges': '/org-edges/integrity',
};

export const integrityChecksApi = {
  /** @returns {Promise<{ ranAt, healthy, totalViolations, results, openContractLimits? }>} */
  run: async (scope) => {
    const path = PATHS[scope];
    if (!path) {
      throw new ApiError(`Unknown integrity scope: ${scope}`, 400);
    }
    try {
      return await authenticatedApi.get(`${API_BASE_URL}${path}`);
    } catch (error) {
      throw new ApiError(error?.message || 'Failed to run the integrity checks', error?.status || 500, error?.data || null);
    }
  },
};
